import { render, staticRenderFns } from "./WarehouseSettingsWidget.vue?vue&type=template&id=a4c47222&"
import script from "./WarehouseSettingsWidget.vue?vue&type=script&lang=js&"
export * from "./WarehouseSettingsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSpinner,QMarkupTable,QIcon,QToggle,QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpinner,QMarkupTable,QIcon,QToggle,QSelect})
